import {lazy} from "react";

export const ReadersSingleVoyagesLazy = lazy(() => import('./ReadersSingleVoyages'))
